import { workspaceService } from '@/services'
import { Workspace } from '@/types'
import { NodeInviteForm } from '@/components/nodes/NodeInviteForm'
import {
  createPermissionChecker,
  createMemberChecker,
  createAddMemberFunction,
  createRolePermissionsComponent,
  createUserExistsChecker,
} from '@/lib/factories/invite-factories'

export default function WorkspaceInvitePage() {
  return (
    <NodeInviteForm<Workspace>
      nodeType="workspace"
      nodeIdParam="workspaceId"
      getNodeById={workspaceService.getById.bind(workspaceService)}
      canInviteCheck={createPermissionChecker('workspace')}
      isMemberCheck={createMemberChecker('workspace')}
      userExistsCheck={createUserExistsChecker('workspace')}
      addMember={createAddMemberFunction('workspace', workspaceService)}
      getRolePermissions={createRolePermissionsComponent('workspace')}
      description="Invite a user to join this workspace by entering their email address"
    />
  )
}
